import { Alert, Button, Col, Form, Row, Table } from "react-bootstrap";
import { Typography } from "../../components/utilities/Typhograpy";
import { FormProvider, useForm } from "react-hook-form";
import { getUserInfo } from "../../api/UsersApi";
import { useContext, useEffect, useState } from "react";
import GlobalContext from "../../context/GlobalContext";
import BoxSkeleton from "../../components/utilities/BoxSkeleton";
import BackButton from "../../components/button/BackButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import swal from "../../services/swalConfig";
import SelectPersonnel from "../../components/select/SelectPersonnel";
import SelectCoordinate from "../../components/select/SelectCoordinate";
import { format } from "date-fns";
import RadioAttendanceCategory from "../../components/radio/RadioAttendanceCategory";
import InfoIcon from "../../components/utilities/InfoIcon";
import { createAttendance } from "../../api/AttendanceApi";
import TruncatedTextWithTooltip from "../../components/utilities/TruncatedTextWithTooltip";

import { tr } from "../../i18n";
const AttendanceCreate = () => {
  const { user, setLoading } = useContext(GlobalContext);
  const [paidLeave, setPaidLeave] = useState(null);
  const [schedules, setSchedules] = useState(null);
  const methods = useForm({
    defaultValues: {
      personnel: null,
      category: "Attendance",
      time_in: "08:00",
      time_out: "17:00",
      location: null,
    },
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
    setError,
    watch,
    reset,
  } = methods;

  const loadPersonnelInfo = async (idPersonnel) => {
    const result = await getUserInfo(idPersonnel);

    if (result.status == 200) {
      setPaidLeave(result.data.internal_paid_leave);
      setSchedules(result.data.schedules);
    }
  };

  useEffect(() => {
    const personnel = watch("personnel");
    setPaidLeave(null);
    setSchedules(null);

    if (personnel !== undefined && personnel !== null && personnel !== "") {
      loadPersonnelInfo(personnel);
    }
  }, [watch("category"), watch("personnel")]);

  const handleCreateAttendance = async (data) => {
    const response = await createAttendance(data);
    return response;
  };

  const onHandleSubmit = handleSubmit(async (data) => {
    const processAttendance = async (dataToProcess) => {
      try {
        setLoading(true);
        const response = await handleCreateAttendance(dataToProcess);

        if (response.status === 409) {
          // Matikan loading sebelum menampilkan SweetAlert2
          setLoading(false);

          if (response.error_code === "HOLIDAY_CONFLICT") {
            const result = await swal.fire({
              text: response.message,
              icon: "warning",
              showCancelButton: false,
              showDenyButton: true,
              confirmButtonText:
                tr("attendance:proceed_all_mark_non_working_days"),
              confirmButtonColor: "#f1c40f",
              denyButtonText: tr("attendance:proceed_scheduled_days_only"),
              denyButtonColor: "#3498db",
              cancelButtonText: tr("common:actions.cancel"),
              timer: false,
              didOpen: () => {
                const actions = swal.getActions();
                actions.style.display = "flex";
                actions.style.flexDirection = "column";
                const buttons = actions.querySelectorAll("button");
                buttons.forEach((button) => {
                  button.style.width = "100%";
                });
              },
            });

            if (result.isConfirmed) {
              await processAttendance({
                ...dataToProcess,
                action_type: "proceed_all_as_overtime",
              });
            } else if (result.isDenied) {
              await processAttendance({
                ...dataToProcess,
                action_type: "proceed_scheduled_only",
              });
            }
          } else {
            swal.fire({
              title: tr("common:errors.oops"),
              text: response.message,
              icon: "error",
              showCancelButton: false,
            });
          }
        } else if (response.status === 200) {
          // Jika tidak ada konflik, tampilkan notifikasi sukses
          swal.fire({
            title: tr("shared:success"),
            text: response.message,
            icon: "success",
          });

          reset();
        } else {
          swal.fire({
            title: tr("common:errors.oops"),
            text: response.message,
            icon: "error",
            showCancelButton: false,
          });
        }
      } catch (error) {
        swal.fire({
          title: tr("common:errors.oops"),
          text: tr("common:errors.generic"),
          icon: "error",
          showCancelButton: false,
        });
      } finally {
        // Pastikan loading dimatikan jika ada error di SweetAlert atau proses lain
        setLoading(false);
      }
    };

    const initialData = {
      ...data,
      company_id: user.workspace.company_id,
      action_type: null,
    };

    // Mulai proses
    await processAttendance(initialData);
  });

  return (
    <>
      <Row>
        <Col lg={7}>
          <div className="box-shadow">
            <FormProvider {...methods}>
              <Form onSubmit={handleSubmit(onHandleSubmit)}>
                <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm="3">
                    <Typography variant="form">
                      {tr("attendance:category")}
                      <InfoIcon
                        type="html"
                        info="Attendance: Refers to the presence of an employee at work during scheduled hours <br/><br/> LWP (Leave With Pay): Paid leave that consumes personnel paid leave quota. <br/><br/> LWOP (Leave Without Pay): Authorized leave where the employee is not paid during the leave period. <br/><br/> SL (Special Leave): Paid leave that does not consume paid leave quota, for cases like maternity leave, sick tolerance, and other company policies."
                      />
                    </Typography>
                  </Form.Label>
                  <Col sm="9" className="d-flex align-items-center">
                    <RadioAttendanceCategory />
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm="3">
                    <Typography variant="form">
                      {tr("attendance:staff")}{" "} <span class="text-danger">*</span>
                    </Typography>
                  </Form.Label>
                  <Col sm="9">
                    <SelectPersonnel
                      name="personnel"
                      rules={{ required: tr("attendance:staff_is_required") }}
                    />
                    {watch("category") === "LWP" &&
                    watch("personnel") &&
                    watch("personnel") !== "" ? (
                      paidLeave === null ? (
                        <BoxSkeleton count="1" size="12" height="20px" />
                      ) : (
                        <Alert
                          variant={paidLeave > 0 ? "warning" : "danger"}
                          className="mt-2 mb-1 p-2"
                        >
                          {tr("attendance:the_remaining_paid_leave_is")}{" "} <b>{paidLeave}</b> {" "}{tr("attendance:days")}
                        </Alert>
                      )
                    ) : null}
                    {errors.personnel ? (
                      <small className="text-danger">
                        {errors.personnel.message}
                      </small>
                    ) : (
                      ""
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm="3">
                    <Typography variant="form">
                      {tr("attendance:date")}{" "} <span class="text-danger">*</span>
                    </Typography>
                  </Form.Label>
                  <Col sm="9">
                    <Row>
                      <Col size="6">
                        <input
                          {...register(`date_from`, {
                            required: tr("attendance:date_is_required"),
                          })}
                          type="date"
                          className="form-control"
                          defaultValue={format(new Date(), "yyyy-MM-dd")}
                        />
                        {errors.date ? (
                          <small className="text-danger">
                            {errors.date.message}
                          </small>
                        ) : (
                          ""
                        )}
                      </Col>
                      <Col size="6">
                        <input
                          {...register(`date_to`, {
                            required: tr("attendance:date_is_required"),
                          })}
                          type="date"
                          className="form-control"
                          defaultValue={format(new Date(), "yyyy-MM-dd")}
                        />
                        {errors.date ? (
                          <small className="text-danger">
                            {errors.date.message}
                          </small>
                        ) : (
                          ""
                        )}
                      </Col>
                    </Row>
                  </Col>
                </Form.Group>

                {(watch("category") === "Attendance" ||
                  watch("category") === "Overtime") && (
                  <>
                    <Form.Group as={Row} className="mb-2">
                      <Form.Label column sm="3">
                        <Typography variant="form">
                          {tr("attendance:time")}{" "} <span className="text-danger">*</span>
                        </Typography>
                      </Form.Label>
                      <Col sm="9">
                        <Row>
                          <Col sm="6">
                            <input
                              {...register("time_in", {
                                required: tr("attendance:time_in_is_required"),
                              })}
                              type="time"
                              className="form-control input-time"
                              defaultValue={null}
                            />
                            {errors.time_in ? (
                              <small className="text-danger">
                                {errors.time_in.message}
                              </small>
                            ) : (
                              ""
                            )}
                          </Col>
                          <Col sm="6">
                            <input
                              {...register("time_out", {
                                required: tr("attendance:time_out_is_required"),
                              })}
                              type="time"
                              className="form-control input-time"
                              defaultValue={null}
                            />
                            {errors.time_out ? (
                              <small className="text-danger">
                                {errors.time_out.message}
                              </small>
                            ) : (
                              ""
                            )}
                          </Col>
                        </Row>
                      </Col>
                    </Form.Group>

                    <Form.Group as={Row} className="mb-2">
                      <Form.Label column sm="3">
                        <Typography variant="form">{tr("shared:location")}</Typography>
                      </Form.Label>
                      <Col sm="9">
                        <SelectCoordinate
                          name="location"
                          rules={null}
                          placeholder={tr("attendance:choose_location")}
                        />
                      </Col>
                    </Form.Group>
                  </>
                )}

                <Form.Group as={Row} className="mb-2">
                  <Form.Label column sm="3">
                    <Typography variant="form">{tr("shared:description")}</Typography>
                  </Form.Label>
                  <Col sm="9">
                    <textarea
                      {...register("description")}
                      className="form-control"
                      placeholder={`${
                        watch("category")?.charAt(0).toUpperCase() +
                        watch("category").slice(1)
                      } description`}
                    />
                  </Col>
                </Form.Group>

                <Col
                  lg={12}
                  md={12}
                  sm={12}
                  className="mt-3 d-flex justify-content-between"
                >
                  <BackButton />
                  <Button type="submit" className="btn btn-primary">
                    <FontAwesomeIcon icon={faCheckCircle} /> {" "}{tr("attendance:create")}
                  </Button>
                </Col>
              </Form>
            </FormProvider>
          </div>
        </Col>

        {schedules && (
          <Col lg={5}>
            <table>
              <thead>
                <tr>
                  <th rowSpan={2}>{tr("shared:day")}</th>
                  <th colSpan={2} className="text-center">
                    {tr("attendance:time")}
                  </th>
                  <th rowSpan={2}>{tr("shared:location")}</th>
                </tr>
                <tr>
                  <th>{tr("attendance:in")}</th>
                  <th>{tr("attendance:out")}</th>
                </tr>
              </thead>
              <tbody>
                {schedules.map((schedule) => (
                  <tr key={schedule.schedule_id}>
                    <td>{schedule.schedule_day}</td>
                    <td>{schedule.schedule_time_in}</td>
                    <td>{schedule.schedule_time_out}</td>
                    <td>
                      <TruncatedTextWithTooltip
                        text={schedule.map_name}
                        maxLength="80px"
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </Col>
        )}
      </Row>
    </>
  );
};

export default AttendanceCreate;
